// used for post signup import workflows
export class CommonPermissionFactory {
  constructor({
    permissions,
  }) {
    this.permissions = permissions;
  }

  // set these values to true for webui, MAE can customize the implementation
  isProvideFeedbackButtonEnabled = () => true;

  isViewImportedCampaignsButtonEnabled = () => true;

  isCurrencyConvertorRelocateEnabled = () => true;

  IsImportSmartScheduleStepImprovementEnabled = () => this.permissions && this.permissions.dynamic && this.permissions.dynamic.ImportSmartScheduleStepImprovement;

  IsImportSmartScheduleStepImprovementPhaseTwoEnabled = () => this.permissions && this.permissions.dynamic && this.permissions.dynamic.ImportSmartScheduleStepImprovementPhaseTwo;

  IsImportPhase2TrackingUrlEnabled = () => this.permissions && this.permissions.dynamic && this.permissions.dynamic.ImportPhase2TrackingUrl;

  // panel improvement pilot is under smart import schedule step improvement phase two
  IsImportSmartScheduleStepPanelImprovementEnabled = () => this.permissions && this.permissions.dynamic && this.permissions.dynamic.ImportSmartScheduleStepImprovementPhaseTwo && this.permissions.dynamic.ImportSmartScheduleStepPanelImprovement;

  // panel data restore improvement pilot is under smart import schedule step improvement phase two
  IsImportSmartScheduleStepPanelDataRestoreImprovementEnabled = () => this.permissions && this.permissions.dynamic && this.permissions.dynamic.ImportSmartScheduleStepImprovementPhaseTwo && this.permissions.dynamic.ImportSmartScheduleStepPanelDataRestoreImprovement;

  IsOneClickImportEnabled = () => false;

  IsImportFromMetaButtonEnabled = () => false;
}

